import React from "react";
import CookieConsent from "react-cookie-consent";
import Cookies from "js-cookie";
import "./cookieBanner.css";

const CookieBanner: React.FC = () => {
  return (
    <CookieConsent
      location="bottom"
      buttonText="Acceptera"
      declineButtonText="Neka"
      enableDeclineButton
      onAccept={() => Cookies.set("cookie_consent", "true", { expires: 365 })}
      onDecline={() => Cookies.set("cookie_consent", "false")}
      containerClasses="cookie-banner"
      buttonClasses="cookie-banner__button"
      declineButtonClasses="cookie-banner__decline-button"
      disableStyles={true}
    >
      Alpine Sport använder cookies för att förbättra din upplevelse.
    </CookieConsent>
  );
};

export default CookieBanner;

